import { ResponseManipulatorType } from '../../cache-logic-interface';

export let customSubscriptionManipulator: ResponseManipulatorType = {
  default: (cache, cacheKey, request) => {
    return cache.getCacheData(cacheKey);
  },
};
